module.exports = __webpack_public_path__ + "uvodBanner_new2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/homeSlider/uvodBanner_new2.jpg
// module id = 907
// module chunks = 0